import { render, staticRenderFns } from "./UmkmBermitraMain.vue?vue&type=template&id=1f658917&scoped=true"
import script from "./UmkmBermitraMain.vue?vue&type=script&lang=js"
export * from "./UmkmBermitraMain.vue?vue&type=script&lang=js"
import style0 from "./UmkmBermitraMain.vue?vue&type=style&index=0&id=1f658917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f658917",
  null
  
)

export default component.exports